import React from 'react';
import { Droppable } from 'react-beautiful-dnd';

import ErrorBoundary from 'components/core/ErrorBoundary.component';

const STRATEGY = 'console';

const DndDroppable = ({ tag, ...extra }) => (
  <ErrorBoundary strat={STRATEGY} tag={tag}>
    <Droppable {...extra} />
  </ErrorBoundary>
);

export default DndDroppable;
